import { Component, Input, HostListener, ViewChildren, ElementRef, QueryList } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AnalysisOptionsComponent } from '../../tools/analysis-options/analysis-options.component';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FacadeService } from '../../services/facade.service';
import { ProyectosService } from '../../services/proyectos.service';

import { AnalysisServiceService } from '../../services/analysis-service/analysis-service.service';

@Component({
  selector: 'statistics',
  standalone: true,
  imports: [CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    AnalysisOptionsComponent,
    MatTooltipModule,
    FormsModule,
    HttpClientModule],
  templateUrl: './statistics.component.html',
  styleUrl: './statistics.component.css',
})
export class StatisticsComponent {

  @ViewChildren('eyeIcon') eyeIcons!: QueryList<ElementRef<HTMLImageElement>>;

  isEditing_Sentence = false;
  isEditing_Word = false;
  isEditing_Unique = false;
  isEditing_Syllable = false;

  UpdateStatistics = false;

  excludeDigits: boolean;

  loaderActive: boolean;
  loaderActive2: boolean;
  loaderActiveFirstProject: boolean;

  verifyLoaderActive2: boolean;

  activeEyeIcon: HTMLImageElement | null = null;

  public statistics: any = {
    sentenceCount: null,
    wordCount: null,
    uniqueWordCount: null,
    averageSentenceLength: null,
    uniqueWordsRatio: null,
    numberCount: null,
    totalDigits: null,
    syllableCount: null,
    wordsWithMoreThan2Syllables: null,
    wordsWithMoreThan2SyllablesPercentage: null,
    averageSyllablesPerSentence: null,
    averageSyllablesPerWord: null,
    syllablesPer100Words: null,
    wordsWithMoreThan2Syllables_data: null
  }

  @Input() checked: boolean; //Variable del mat-slide-toggle del text-component
  project_data: any;
  private proyectoSub: any;

  public hideEyeIconsForSafari1561 = false;

  // activeEyeIcon: HTMLImageElement | null = null;

  constructor(
    private http: HttpClient,
    public fachada: FacadeService,
    public proyectoService: ProyectosService,
    private analysisService: AnalysisServiceService
  ) {
    this.checked = true;
  }

  ngOnInit(): void {
    localStorage.setItem("actual", "statistics")
    this.isButtonDisabled();
    this.initSubscribe();
    if(sessionStorage.getItem("id_project")){
    this.initStatistics();
    }
    this.hideEyeIconsForSafari1561 = false;
    this.analysisService.currentExcludeDigits.subscribe(value => this.excludeDigits = value);
    if (sessionStorage.getItem("text_UID")) {
      this.loaderActive = true;
    }
    this.proyectoService.loader$.subscribe(loader => {
      if (this.loaderActive2) {
        this.loaderActive = false;
      } else {
        this.loaderActive = loader;
      }
    });

        this.proyectoService.loaderAnalyzing$.subscribe(loader => {
      if(loader){
        this.loaderActive2 = true;
        
      }
      if(!loader){
        this.loaderActive2 = false;
      }
      
    });

        this.proyectoService.loaderCreatingProject$.subscribe(value => {
      if(value){
        this.loaderActive2 = true;
        
      }
      if(!value){
        this.loaderActive2 = false;
        
      }
    });

    
        this.proyectoService.verifyloaderAnalyzing$.subscribe(value => {
      if(value){
        this.verifyLoaderActive2 = true;
      }
      if(!value){
        this.verifyLoaderActive2 = false;
      }
    });

     setInterval(() => {
       let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "statistics" && sessionStorage.getItem("statistics") !== "-" && !this.loaderActive && sessionStorage.getItem("id_project") && !this.verifyLoaderActive2) {
       this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.proyectoService.updateloader(false);
          this.initStatistics()
      }
      }, 20 * 1000); // 30 segundos

  }

  initSubscribe() {
    if (!this.proyectoSub || this.proyectoSub.closed) {
      //Subscribimos al servicio para escuchar los datos
      this.proyectoSub = this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject }) => {
        if (!firstProject) {
          this.loaderActive = false;
          if (sessionStorage.getItem("text_UID")) {
            if(!this.loaderActiveFirstProject){
              this.loaderActive2 = true;
            }
          } else {
            this.loaderActive2 = false;
          }
        }
        if (firstProject) {
          this.loaderActive = false;
          if (sessionStorage.getItem("text_UID")) {
            this.loaderActiveFirstProject = true;
          } else {
            this.loaderActiveFirstProject = false;
          }
        }
        console.log("Update de data --Reporta: Statistics--")
        this.project_data = proyecto;
        if (this.eyeIcons && this.eyeIcons.length) {
          this.eyeIcons.forEach(iconRef => {
            iconRef.nativeElement.src = './assets/images/eye-icon.svg';
          });
        }
        this.activeEyeIcon = null;
        if(sessionStorage.getItem("id_project")){
        this.initStatistics();
        }

      });
    }
  }

  status: any;
  async initStatistics() {
    let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "statistics") {
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage = sessionStorage.getItem("statistics");

      if (memoryStorage && !this.UpdateStatistics) {
        if(memoryStorage !== "-"){
        try {
          // Si existe, convertirlo de JSON string a objeto y asignarlo
          this.statistics = JSON.parse(memoryStorage);
          this.listaNumeros();
        } catch (error) {
          console.log("Error en la petición de datos")
          console.log(error)
          sessionStorage.removeItem('statistics');
        } finally {
          this.loaderActive2 = false;
          this.loaderActiveFirstProject = false;
          this.loaderActive = false;
          this.proyectoService.updateloader(false);
        }
        }
      }
      if (!memoryStorage || this.UpdateStatistics) {
        sessionStorage.setItem("statistics", "-");
        //Tenemos que esperar unos milisegundos en lo que el servicio actualiza la info
        await new Promise(resolve => setTimeout(resolve, 10));
        try {
          let textUID = sessionStorage.getItem('text_UID');
          let respuesta = await this.fachada.getStatisticsOfProject(this.http, textUID, "");
          this.statistics = respuesta;
          // Guardar la respuesta en sessionStorage
          sessionStorage.setItem("statistics", JSON.stringify(this.statistics));
          this.listaNumeros();
          this.status = 200
        } catch (error) {

          if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (statistics)");
            sessionStorage.removeItem('statistics');
            this.status = 0

          } else {
            console.log("Otro error en la petición de datos")
            console.log(error)
            sessionStorage.removeItem('statistics');
          }
          this.status = error?.status;

        } finally {
          if (this.status === 0) {
            this.loaderActive2 = true;
            this.loaderActiveFirstProject = true;
            this.loaderActive = true;
            this.proyectoService.updateloader(true);
            this.UpdateStatistics = true;
            setTimeout(() => {
              this.initStatistics();
            }, 100);
          } else {
            this.loaderActive2 = false;
            this.loaderActiveFirstProject = false;
            this.loaderActive = false;
            this.proyectoService.updateloader(false);
            this.UpdateStatistics = false;
             setTimeout(() => {
              this.initStatistics();
            }, 100);
          }
        }
      }
       }else{
      console.log(`statistics no es la pantalla actual así que bloqueamos peticiones`)
    }
  }

  public isSafariVersion1561(): boolean {
    const ua = navigator.userAgent;
    const safariMatch = ua.match(/Version\/([\d.]+) Safari\//);
    const isSafari = ua.includes("Safari") && ua.includes("Macintosh") && !ua.includes("Chrome");

    if (safariMatch && safariMatch[1] && isSafari) {
      return safariMatch[1] === "15.6.1";
    }

    return false;
  }


  editValue_Sentence() {
    this.isEditing_Sentence = true;
    document.addEventListener('click', this.handleClickOutside);
  }
  editValue_Word() {
    this.isEditing_Word = true;
    document.addEventListener('click', this.handleClickOutsideWord);
  }
  editValue_Unique() {
    this.isEditing_Unique = true;
    document.addEventListener('click', this.handleClickOutsideUnique);
  }
  editValue_Syllable() {
    this.isEditing_Syllable = true;
    document.addEventListener('click', this.handleClickOutsideSyllable);
  }

  saveValue_Sentence() {
    this.UpdateStatistics = true;
    this.isEditing_Sentence = false;
    document.removeEventListener('click', this.handleClickOutside);
    this.initSubscribe()
  }
  saveValue_Word() {
    this.UpdateStatistics = true;
    this.isEditing_Word = false;
    document.removeEventListener('click', this.handleClickOutsideWord);
    this.initSubscribe()
  }
  saveValue_Unique() {
    this.UpdateStatistics = true;
    this.isEditing_Unique = false;
    document.removeEventListener('click', this.handleClickOutsideUnique);
    this.initSubscribe()
  }
  saveValue_Syllable() {
    this.UpdateStatistics = true;
    this.isEditing_Syllable = false;
    document.removeEventListener('click', this.handleClickOutsideSyllable);
    this.initSubscribe()
  }


  onKeyPressSentence(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.saveValue_Sentence();
      this.updateDeMetricas();
    }
  }

  onKeyPressWord(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.saveValue_Word();
      this.updateDeMetricas();
    }
  }

  onKeyPressUnique(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.saveValue_Unique();
      this.updateDeMetricas();
    }
  }

  onKeyPressSyllable(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.saveValue_Syllable();
      this.updateDeMetricas();
    }
  }

  async updateDeMetricas() {
    let new_data = { new_data: this.statistics }
    await this.fachada.UpdateStadisticsMetrics(this.http, sessionStorage.getItem('text_UID'), new_data)
  }

  // Función que se ejecuta cuando se hace clic en cualquier parte del documento SENTENCE
  handleClickOutside = (event: Event) => {
    const target = event.target as HTMLElement;
    if (!target.closest('.editable-input') && !target.closest('.edit-icon')) {
      this.saveValue_Sentence();
      this.updateDeMetricas();
    }
  }

  // Función que se ejecuta cuando se hace clic en cualquier parte del documento WORD
  handleClickOutsideWord = (event: Event) => {
    const target = event.target as HTMLElement;
    if (!target.closest('.editable-input') && !target.closest('.edit-icon')) {
      this.saveValue_Word();
      this.updateDeMetricas();
    }
  }

  // Función que se ejecuta cuando se hace clic en cualquier parte del documento UNIQUE
  handleClickOutsideUnique = (event: Event) => {
    const target = event.target as HTMLElement;
    if (!target.closest('.editable-input') && !target.closest('.edit-icon')) {
      this.saveValue_Unique();
      this.updateDeMetricas();
    }
  }

  // Función que se ejecuta cuando se hace clic en cualquier parte del documento SYLLABLE
  handleClickOutsideSyllable = (event: Event) => {
    const target = event.target as HTMLElement;
    if (!target.closest('.editable-input') && !target.closest('.edit-icon')) {
      this.saveValue_Syllable();
      this.updateDeMetricas();
    }
  }

  // public datos_pagina = {
  //   sentenceCount: 16,
  //   wordCount: 418,
  //   uniqueWordCount: 275,
  //   averageSentenceLength: 27.31,
  //   uniqueWordsRatio: 0.63,
  //   numberCount: 7,
  //   syllableCount: 655,
  //   wordsWithMoreThan2Syllables: 55,
  //   wordsWithMoreThan2SyllablesPercentage: 12.59,
  //   averageSyllablesPerSentence: 40.94,
  //   averageSyllablesPerWord: 1.50,
  //   syllablesPer100Words: 149.89,
  // };

  //Para el cambio de color de los ojos
  toggleEyeIcon(event: Event): void {
    const element = event.target as HTMLImageElement;

    if (this.activeEyeIcon && this.activeEyeIcon !== element) {
      this.activeEyeIcon.src = './assets/images/eye-icon.svg';
      this.proyectoService.undoMarcadoSentencesStatis(this.http); // Desmarcar el texto
    }

    if (element.src.includes('eye-icon.svg')) {
      element.src = './assets/images/yellow_icons/eye-on-icon.svg';
      this.activeEyeIcon = element;
      this.proyectoService.realizarMarcadoSentencesStatis(this.statistics.sentences_data, "sentence", this.http,this.excludeDigits); // Realizar el marcado
    } else {
      element.src = './assets/images/eye-icon.svg';
      this.activeEyeIcon = null;
      this.proyectoService.undoMarcadoSentencesStatis(this.http); // Desmarcar el texto
    }
  }

  toggleEyeIcon2sylla(event: Event, array_data = null): void {
    const element = event.target as HTMLImageElement;
    // Si hay un icono activo y no es el mismo que se hizo clic, restablecer su imagen
    if (this.activeEyeIcon && this.activeEyeIcon !== element) {
      this.activeEyeIcon.src = './assets/images/eye-icon.svg';
    }

    // Cambiar la imagen del icono actual
    if (element.src.includes('eye-icon.svg')) {
      //Prende 
      this.proyectoService.realizarMarcado3Statis(array_data, "k1", this.http)
      element.src = './assets/images/yellow_icons/eye-on-icon.svg';
      this.activeEyeIcon = element; // Establecer el icono actual como activo
    } else {
      //Apaga
      this.proyectoService.undoMarcadoMultiple(this.http)
      element.src = './assets/images/eye-icon.svg';
      this.activeEyeIcon = null; // No hay icono activo
    }
  }

  toggleEyeTokens(event: Event, array_data = null): void {
    const element = event.target as HTMLImageElement;
    // Si hay un icono activo y no es el mismo que se hizo clic, restablecer su imagen
    if (this.activeEyeIcon && this.activeEyeIcon !== element) {
      this.activeEyeIcon.src = './assets/images/eye-icon.svg';
    }

    // Cambiar la imagen del icono actual
    if (element.src.includes('eye-icon.svg')) {
      //Prende 
      this.proyectoService.realizarMarcadoTokensWordsStatis(array_data, "k1", this.http)
      element.src = './assets/images/yellow_icons/eye-on-icon.svg';
      this.activeEyeIcon = element; // Establecer el icono actual como activo
    } else {
      //Apaga
      this.proyectoService.undoMarcadoMultiple(this.http)
      element.src = './assets/images/eye-icon.svg';
      this.activeEyeIcon = null; // No hay icono activo
    }
  }

  toggleEyeUniqueTokens(event: Event, array_data = null): void {
    const element = event.target as HTMLImageElement;
    // Si hay un icono activo y no es el mismo que se hizo clic, restablecer su imagen
    if (this.activeEyeIcon && this.activeEyeIcon !== element) {
      this.activeEyeIcon.src = './assets/images/eye-icon.svg';
    }

    // Cambiar la imagen del icono actual
    if (element.src.includes('eye-icon.svg')) {
      //Prende 
      this.proyectoService.realizarMarcadoUniqueTokensStatis(array_data, "k1", this.http)
      element.src = './assets/images/yellow_icons/eye-on-icon.svg';
      this.activeEyeIcon = element; // Establecer el icono actual como activo
    } else {
      //Apaga
      this.proyectoService.undoMarcadoMultiple(this.http)
      element.src = './assets/images/eye-icon.svg';
      this.activeEyeIcon = null; // No hay icono activo
    }
  }

  toggleEyeIconNumbers(event: Event): void {
    const element = event.target as HTMLImageElement;

    if (this.activeEyeIcon && this.activeEyeIcon !== element) {
      this.activeEyeIcon.src = './assets/images/eye-icon.svg';
      this.proyectoService.undoMarcadoSentencesStatis(this.http); // Desmarcar el texto
    }

    if (element.src.includes('eye-icon.svg')) {
      element.src = './assets/images/yellow_icons/eye-on-icon.svg';
      this.activeEyeIcon = element;
      this.proyectoService.realizarMarcadoNumbersStatis(this.http); // Realizar el marcado
    } else {
      element.src = './assets/images/eye-icon.svg';
      this.activeEyeIcon = null;
      this.proyectoService.undoMarcadoSentencesStatis(this.http); // Desmarcar el texto
    }
  }

  listaDeNumeros: string[] = []; // aquí guardaremos los números

  listaNumeros() {
    this.listaDeNumeros = this.proyectoService.listaNumbersStatis();
  }


  limitsSentence(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = Number(input.value);

    // Asegurar que el valor esté en el rango permitido
    if (value > 1000) {
      value = 1000; // Límite superior
    } else if (value < 0) {
      value = 0; // Límite inferior
    }

    input.value = value.toString();
    this.statistics.sentenceCount = value;
  }

  limitsToken(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = Number(input.value);

    // Asegurar que el valor esté en el rango permitido
    if (value > 1000) {
      value = 1000; // Límite superior
    } else if (value < 0) {
      value = 0; // Límite inferior
    }

    input.value = value.toString();
    this.statistics.wordCount = value;
  }

  limitsUnique(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = Number(input.value);

    // Asegurar que el valor esté en el rango permitido
    if (value > 1000) {
      value = 1000; // Límite superior
    } else if (value < 0) {
      value = 0; // Límite inferior
    }

    input.value = value.toString();
    this.statistics.uniqueWordCount = value;
  }

  limitsSyllable(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = Number(input.value);

    // Asegurar que el valor esté en el rango permitido
    if (value > 1000) {
      value = 1000; // Límite superior
    } else if (value < 0) {
      value = 0; // Límite inferior
    }

    input.value = value.toString();
    this.statistics.syllableCount = value;
  }

  isButtonDisabled(): boolean {
    return !sessionStorage.getItem("text_UID");
  }
}
